import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  Advertisement,
  AdvertisementResponse,
  BannerStore,
} from 'src/app/stores/banner.store';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss'],
})
export class AdvertisementComponent implements OnInit {
  index: number = 0;
  @Input() advertisementData: Array<Advertisement> = [];
  imageUrl = imageUrl;
  constructor(
    private modalCtrl: ModalController,
    public bannerStore: BannerStore
  ) {}

  ngOnInit() {}

  async ionViewDidEnter() {
    this.index = 0;
  }

  showNext(event) {
    event?.stopPropagation()
    this.index = this.index + 1;
    if (this.index == this.advertisementData.length) {
      this.dismiss();
    }
  }

  dismiss() {
    console.log("here")
    this.modalCtrl.dismiss();
  }
  openPage() {
    this.bannerStore.advertisementRedirect(this.advertisementData[this.index]);
    this.dismiss();
  }
}
